import React from 'react';
import BlueButton from "../BlueButton/BlueButton.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
import Api from "../../Api.js";
import {word} from "../../word.js";
import Loader from "../BlueButton/Loader.js";
import {Col, Modal, Row} from "react-bootstrap";
import {TextField} from "@mui/material";

function SurveyFinish({onHide, show,getData}) {
    const [value, setValue] = React.useState('');
    const [submitted, setSubmitted] = React.useState(false);
    const handleFinish = async () => {
        try {
            setSubmitted(true);
            await Api.updateSurveyStatus(show,{finish:value,status:'ended'})
            await getData();
            onHide();
            setSubmitted(false);
        } catch (e) {
            ErrorToast()
            console.error("Error finishing survey:", e);
        }
    }
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>Հարցումի ավարտ</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div
                                className={!value && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='text'
                                    style={{width: "100%"}}
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}
                                    label="Պատճառ"
                                    multiline
                                    variant="outlined"
                                    error={!value && submitted}
                                    className={!value && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!value && submitted &&
                                <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            <BlueButton
                                disabled={submitted}
                                onChangeValue={() => handleFinish()}
                                title={submitted?(
                                    <Loader size={15}/>
                                ):"Հաստատել"}/>

                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default SurveyFinish;